<template>
  <div
    class="tooth"
    v-click-outside="onCloseMenu">
    <tooth-popover-menu
      v-bind:value="isShowMenu"
      v-bind:flip="flip">
      <template slot="trigger">
        <div class="tooth__body">
          <button
            class="tooth__body__bone"
            type="button"
            v-bind:class="{ [round]: true, selected: isSelected('bone') }"
            v-bind:style="{ 'background-color': partColor['bone'] || '#ffead2' }"
            v-on:click="onClick('bone', $event)" />
          <button
            class="tooth__body__gingiva round-left"
            type="button"
            v-bind:class="round"
            v-bind:style="{ 'background-color': partColor['gingiva'] || '#f4ddc1' }"
            v-on:click="onClick('gingiva', $event)" />
          <button
            class="tooth__body__all-tooth"
            type="button"
            v-on:click="onClick('all', $event)" />
          <svg
            v-if="!isDeleted"
            class="tooth__parts"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none">
            <path
              v-if="isShowPart('root_2')"
              d="M32.3832 37.7709C30.4713 51.2518 28.3344 54.285 27.3222 54.8467L26.7268 78.0566L42.6965 77.3767L41.4929 53.8356C39.6035 54.8242 38.6812 47.9564 38.4563 44.399C38.5313 36.6474 38.4788 20.4029 37.669 17.4371C36.8593 14.4713 35.9821 16.2014 35.6447 17.4371C35.1948 19.7214 33.9127 26.9861 32.3832 37.7709Z"
              v-bind:class="{ selected: isSelected('root_2') }"
              v-bind:fill="partColor['root_2'] || '#FFF'"
              v-on:click="onClick('root_2', $event)"
              v-on:keydown="onClick('root_2', $event)" />
            <path
              v-if="isShowPart('root_3')"
              d="M46.8916 23.2785C45.8795 33.0522 43.3827 52.8467 41.4933 53.8353L39.0225 73.6902L52.0629 76.9775C51.9511 75.8916 51.9301 68.2823 52.7398 46.5331C53.752 19.3466 51.9526 12.4938 50.8279 8.56183C50.0117 5.70826 48.0054 9.62462 47.7641 12.5828L46.8916 23.2785Z"
              v-bind:class="{ selected: isSelected('root_3') }"
              v-bind:fill="partColor['root_3'] || '#FFF'"
              v-on:click="onClick('root_3', $event)"
              v-on:keydown="onClick('root_3', $event)" />
            <path
              v-if="isShowPart('root_1')"
              d="M18.3255 43.5004L17.7632 78.4385L30.5431 77.8943L27.3227 54.8469C26.513 55.2962 26.3105 49.4919 26.3105 46.5336C26.9479 31.1429 27.4577 0.428833 24.3986 0.698456C21.3396 0.968071 19.0753 29.3454 18.3255 43.5004Z"
              v-bind:class="{ selected: isSelected('root_1') }"
              v-bind:fill="partColor['root_1'] || '#FFF'"
              v-on:click="onClick('root_1', $event)"
              v-on:keydown="onClick('root_1', $event)" />
            <path
              v-if="isShowPart('root_1')"
              d="M21.6157 64.4155L20.9289 64.2734C20.5793 64.2011 20.2598 64.0246 20.0125 63.7673C19.5842 63.3215 19.4052 62.6943 19.5221 62.0873C21.798 50.2635 21.2608 35.4132 21.8315 32.6138C21.8486 32.5295 21.8826 32.4595 21.9308 32.3883C22.1349 32.0874 22.5679 32.0388 22.8037 32.3156C22.8772 32.402 22.9294 32.4735 22.9299 32.5034C23.1353 43.0029 24.8188 56.4937 26.5156 62.3723L26.6585 62.8995C26.7559 63.2594 26.6702 63.6443 26.4291 63.9288C26.2777 64.1074 26.0747 64.2348 25.848 64.2934L25.2758 64.4413L24.203 64.5559L23.1462 64.5485L21.6157 64.4155Z"
              v-bind:class="{ selected: isSelected('distal_cheek_canal') }"
              v-bind:fill="partColor['distal_cheek_canal'] || '#FF82BE'"
              v-on:click="onClick('distal_cheek_canal', $event)"
              v-on:keydown="onClick('distal_cheek_canal', $event)" />
            <path
              v-if="isShowPart('root_3')"
              d="M48.0788 63.3441L48.7789 63.2549C49.1352 63.2095 49.4694 63.0573 49.7376 62.8182C50.202 62.4042 50.4302 61.7889 50.3601 61.1707C48.9946 49.1309 50.6866 34.2728 50.3314 31.4197C50.3207 31.3339 50.2921 31.261 50.2492 31.1859C50.0679 30.868 49.6371 30.7857 49.3791 31.0451C49.2986 31.126 49.2407 31.1938 49.2378 31.2238C48.2166 41.7422 45.48 55.1473 43.3211 60.9137L43.1369 61.4315C43.0111 61.7851 43.0673 62.1779 43.2871 62.482C43.4251 62.6731 43.6189 62.8166 43.8418 62.893L44.4044 63.0858L45.4719 63.2842L46.5328 63.3587L48.0788 63.3441Z"
              v-bind:class="{ selected: isSelected('medial_cheek_canal') }"
              v-bind:fill="partColor['medial_cheek_canal'] || '#FF82BE'"
              v-on:click="onClick('medial_cheek_canal', $event)"
              v-on:keydown="onClick('medial_cheek_canal', $event)" />
            <path
              v-if="isShowPart('root_2')"
              d="M35.665 59.3382L36.2973 59.2236C36.6191 59.1653 36.9157 59.0109 37.1481 58.7807C37.5506 58.3821 37.7287 57.8117 37.6354 57.253C35.8182 46.3709 36.6464 32.7802 36.187 30.2029C36.1732 30.1254 36.1436 30.0605 36.1011 29.9942C35.921 29.7139 35.5254 29.6596 35.3032 29.9079C35.2339 29.9853 35.1845 30.0496 35.1833 30.077C34.7576 39.6899 32.9102 52.0094 31.2228 57.3557L31.0801 57.8354C30.9826 58.1629 31.0525 58.5174 31.2669 58.7834C31.4015 58.9505 31.5846 59.0718 31.7909 59.1306L32.3117 59.279L33.2918 59.4083L34.2599 59.4254L35.665 59.3382Z"
              v-bind:class="{ selected: isSelected('palatal_canal') }"
              v-bind:fill="partColor['palatal_canal'] || '#FF82BE'"
              v-on:click="onClick('palatal_canal', $event)"
              v-on:keydown="onClick('palatal_canal', $event)" />
            <path
              d="M50.777 67.5207L52.9824 68.765C53.7546 70.6965 54.351 72.6938 54.7641 74.7326L54.9556 75.6774L55.536 80.2396L55.8211 82.872C55.9402 83.971 55.9395 85.0797 55.8192 86.1785L55.7888 86.4559C55.6979 87.2866 55.5238 88.106 55.2692 88.902L54.9499 89.9002C54.7997 90.37 54.5857 90.8171 54.3141 91.2289L53.9129 91.837C53.6084 92.2986 53.1784 92.6636 52.6735 92.8891C51.9788 93.1994 51.19 93.2246 50.4769 92.9591L49.7324 92.682L49.7097 92.6719C49.1283 92.4122 48.4692 92.3869 47.8696 92.6011C47.7189 92.6549 47.5739 92.7232 47.4365 92.8051L45.786 93.788L44.0449 94.4793L42.4199 94.894L41.6669 95.0221C41.0866 95.1209 40.499 95.1705 39.9103 95.1705C39.1865 95.1705 38.4646 95.0955 37.7563 94.9466L36.8485 94.7558L35.1074 94.2028L33.6474 93.8959C33.3062 93.8242 32.9584 93.788 32.6097 93.788C31.8845 93.788 31.1679 93.9444 30.5086 94.2464L30.0002 94.4793L26.7502 95.447L23.9645 96L21.9913 96L20.3663 95.447L19.0895 94.4793L18.161 93.5115L17.3485 91.9908L17.0002 89.5023L17.0002 87.2903L17.0002 85.3548L17.0002 81.3456L17.3485 78.5806L18.0449 74.8479L18.2455 73.295C18.2663 73.1336 18.3179 72.9777 18.3973 72.8358C18.4713 72.7036 18.5682 72.5857 18.6836 72.4876L19.4766 71.8129C19.9116 71.4429 20.4086 71.1529 20.9448 70.9564C21.4076 70.7868 21.8937 70.689 22.3861 70.6664L24.661 70.5622L28.4913 70.2857L28.7137 70.2416C30.8841 69.8107 33.0208 69.2249 35.1074 68.4885L39.286 67.106L42.5041 66.299C43.2961 66.1004 44.1096 66 44.9262 66C45.805 66 46.68 66.1163 47.5283 66.346L48.8038 66.6912L50.777 67.5207Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
        </div>
      </template>
      <form-teeth-formula-diagnoses
        v-bind:class="{ 'disable-component': disabled }"
        v-bind:is-deleted="needDeleted"
        v-bind:part-list="partList"
        v-on:cancel="onCloseMenu"
        v-on:change-diagnoses="onChangeDiagnoses"
        v-on:change-tooth-deleted="onChangeToothDeleted"
        v-on:submit="onSubmit" />
    </tooth-popover-menu>
    <top-tooth-surface
      v-bind:surface="surface"
      v-bind:part-selected="partSelected"
      v-bind:selected-parts="selectedParts"
      v-bind:flip="flip"
      v-on:select="onClick" />
    <div class="tooth__number">{{ tooth.number }}</div>
  </div>
</template>
<script>
import toothMixin from '@/mixins/toothMixin';
import ToothPopoverMenu from '../ToothPopoverMenu.vue';
import FormTeethFormulaDiagnoses from '../FormTeethFormulaDiagnoses.vue';
import TopToothSurface from '../TopToothSurface.vue';

export default {
  components: {
    ToothPopoverMenu,
    FormTeethFormulaDiagnoses,
    TopToothSurface,
  },
  computed: {
    /**
     * @description Список диагнозов частей зуба для исключения.
     * @type {Object.<string,string[]>}
     */
    excludePartDiagnosis() {
      const excluded = {
        gingiva: ['hood_dissection'],
      };
      const filter = this.partSelected === 'all'
        ? this.filterBySelectedDiagnoses
        : this.filterByHiddenParts;
      const excludedParts = ['root_1', 'root_2', 'root_3'].filter(filter);
      if (excludedParts.length === 1) {
        const [root] = excludedParts;
        excluded[root] = ['root_deleted'];
      }
      return excluded;
    },
    round: ({ flip }) => (flip ? 'round-right' : 'round-left'),
  },
  name: 'ToothUp8',
  mixins: [toothMixin],
};
</script>

<style scoped>
.tooth__body__bone.round-left {
  border-radius: 20px 0 0 0;
}
.tooth__body__bone.round-right {
  border-radius: 0 20px 0 0;
}
.tooth__body__gingiva.round-left {
  border-radius: 0 0 0 10px;
}
.tooth__body__gingiva.round-right {
  border-radius: 0 0 10px 0;
}

.disable-component {
  pointer-events: none;
}
</style>
